<template>
  <div class="login">
    <h1>Login</h1>
    <div class="mt-10">
      <v-input
        v-model="username"
        type="text"
        placeholder="Username"
        class="mb-3"
      />
      <v-input
        v-model="password"
        type="password"
        placeholder="Password"
      />
    </div>
    <div class="mt-10">
      <v-button
        class="btn--secondary"
        @click.prevent="login()"
      >
        Login
      </v-button>
    </div>
  </div>
</template>

<script>
import Auth from '@/auth';

export default {
  name: 'Login',
  data() {
    return {
      username: '',
      password: '',
    };
  },
  methods: {
    async login() {
      const success = await Auth.login(this.username, this.password);

      if (success) {
        this.$router.push({name: 'home'});
      } else {
        this.$router.push({name: '403'});
      }
    },
  },
};
</script>

<style lang="scss">
.login {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  input, button {
    font-size: 3rem;
  }
}
</style>
